module.exports = __webpack_public_path__ + "static/img/kaufmann.2a895b3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logos/kaufmann.png
// module id = 491
// module chunks = 1